import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { BrandMark } from "@/components/layout/AppShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function SetupPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ setup_token: "", email: "", name: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/setup", form);
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#EEF2F9] p-6">
      <div className="w-full max-w-md tqi-card p-8 tqi-rise" data-testid="setup-card">
        <BrandMark />
        <h1 className="mt-6 text-2xl font-extrabold tracking-tight text-[#101C47]">Protected first-admin setup</h1>
        <p className="mt-1 text-sm text-slate-600">Available only while no administrator exists. The setup token is held in the server's secret settings.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-2"><Label htmlFor="token">Setup token</Label><Input id="token" required value={form.setup_token} onChange={set("setup_token")} data-testid="setup-token-input" /></div>
          <div className="space-y-2"><Label htmlFor="semail">Administrator email</Label><Input id="semail" type="email" required value={form.email} onChange={set("email")} data-testid="setup-email-input" /></div>
          <div className="space-y-2"><Label htmlFor="sname">Name</Label><Input id="sname" value={form.name} onChange={set("name")} data-testid="setup-name-input" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-[#101C47] hover:bg-[#1B2D6E] text-white" data-testid="setup-submit-button">{busy ? "Creating…" : "Create administrator"}</Button>
        </form>
        <Link to="/login" className="mt-4 block text-center text-sm text-slate-600 underline" data-testid="setup-back-to-login">Back to sign in</Link>
      </div>
    </div>
  );
}
